<template lang="pug">
  .qty-buttons-v2.text-center
    button.adjustment-btn.xs-f-medium.max-at-tweak(@click="decrementQty" :class="{ 'disabled': minQtyReached }" data-mr-ass="quantity-down")
      .icon-neg

    .month.bold.text-center
      p(data-mr-ass="quantity" :role="touched ? 'alert' : ''" :aria-label="'Quantity ' + localQty" tabindex="0").xs-f-xgrande.max-at-tweak {{ localQty }}
      p.xs-f-xxsmall.max-at-tweak.pt-10 {{ months }}

    button.adjustment-btn.xs-f-medium.max-at-tweak(@click="incrementQty" :class="{ 'disabled': maxQtyReached }" data-mr-ass="quantity-up")
      .icon-pos

</template>

<script>
  import QtyButtonBase from "./QtyButtonBase";

  export default {
    name: "QtyButtonsV2",
    extends: QtyButtonBase,
    computed: {
      months() {
        return `MONTH` + (this.qty != 1 ? 'S' : '');
      }
    }
   }
</script>

<style scoped lang="stylus">
  .qty-buttons-v2
    padding 2.5em 0

    > div
      display inline-block
      vertical-align top

    .adjustment-btn
      width 2.5em
      height 2.5em
      border none
      border-radius 50%
      padding 0.4em
      color color-mr-purple
      background-color color-fog-light

      &.disabled
        color color-gray-triple-nines

    .month
      padding 0.4em 1em

</style>